/* eslint-disable no-unused-vars */
import React from '../../_snowpack/pkg/react.js';
import { observer } from '../../_snowpack/pkg/mobx-react-lite.js';
import { useStore } from '../stores/index.js';
import { formatNumber } from '../utils/utils.js';
import { jsx as __cssprop } from "../../_snowpack/pkg/@emotion/react.js";
export default observer(function Pagination({
  data,
  onRefresh
}) {
  const store = useStore();
  if (!data) {
    return null;
  }
  return __cssprop("div", {
    css: {
      "position": "relative",
      "borderWidth": "1px",
      "borderTopWidth": "0px",
      "height": "4rem",
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgba(243, 244, 246, var(--tw-bg-opacity))"
    }
  }, data.meta.totalItemCount > 0 && __cssprop("div", {
    css: {
      "display": "flex",
      "justifyContent": "center",
      "alignItems": "center",
      "height": "100%",
      "> :not([hidden]) ~ :not([hidden])": {
        "--tw-divide-x-reverse": 0,
        "borderRightWidth": "calc(2px * var(--tw-divide-x-reverse))",
        "borderLeftWidth": "calc(2px * calc(1 - var(--tw-divide-x-reverse)))"
      }
    }
  }, __cssprop("div", {
    css: {
      "paddingLeft": "1rem",
      "paddingRight": "1rem"
    }
  }, __cssprop(Button, {
    disabled: data.meta.isFirstPage,
    onClick: () => store.setPage(1),
    icon: "glyphicon-step-backward"
  }), __cssprop(Button, {
    disabled: !data.meta.hasPreviousPage,
    onClick: () => store.setPage(data.meta.pageNumber - 1),
    icon: "glyphicon-backward"
  })), __cssprop("div", {
    css: {
      "paddingLeft": "1rem",
      "paddingRight": "1rem"
    }
  }, "Page ", data.meta.pageNumber, " of ", formatNumber(data.meta.pageCount)), __cssprop("div", {
    css: {
      "paddingLeft": "1rem",
      "paddingRight": "1rem"
    }
  }, __cssprop(Button, {
    disabled: !data.meta.hasNextPage,
    onClick: () => store.setPage(data.meta.pageNumber + 1),
    icon: "glyphicon-forward"
  }), __cssprop(Button, {
    disabled: data.meta.isLastPage,
    onClick: () => store.setPage(data.meta.pageCount),
    icon: "glyphicon-step-forward"
  }))), __cssprop("div", {
    css: {
      "position": "absolute",
      "right": "1rem",
      "top": "1rem",
      "display": "flex"
    }
  }, __cssprop("div", null, data.meta.totalItemCount === 0 ? 'No records to view' : `View ${data.meta.firstItemOnPage} - ${data.meta.lastItemOnPage} of ${data.meta.totalItemCount}`), __cssprop("button", {
    type: "button",
    css: {
      "marginLeft": "1rem"
    },
    onClick: onRefresh,
    title: "Refresh"
  }, __cssprop("i", {
    className: "glyphicon glyphicon-refresh",
    css: {
      ":hover": {
        "--tw-text-opacity": "1",
        "color": "rgba(156, 163, 175, var(--tw-text-opacity))"
      }
    }
  }))));
});
const Button = ({
  disabled,
  icon,
  onClick
}) => {
  return __cssprop("button", {
    onClick: onClick,
    css: [{
      "paddingLeft": "0.5rem",
      "paddingRight": "0.5rem",
      "letterSpacing": "-0.05em",
      "fontWeight": "700"
    }, disabled && {
      "--tw-text-opacity": "1",
      "color": "rgba(156, 163, 175, var(--tw-text-opacity))"
    }],
    disabled: disabled
  }, __cssprop("span", {
    className: `glyphicon ${icon}`
  }));
};